import personCard from './js/old/personCard';
import './scss/old-acf-blocks/personcard.scss';

personCard();
